import { render, staticRenderFns } from "./AppHeader1.vue?vue&type=template&id=460743af"
import script from "./AppHeader1.vue?vue&type=script&lang=ts"
export * from "./AppHeader1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports